import { lazy, Suspense } from "react";

const IconAmex = lazy(() =>
  import("@assets/ic-amex.svg").then((module) => ({
    default: module.ReactComponent,
  })),
);
const IconVisa = lazy(() =>
  import("@assets/ic-visa.svg").then((module) => ({
    default: module.ReactComponent,
  })),
);
const IconMastercard = lazy(() =>
  import("@assets/ic-mastercard.svg").then((module) => ({
    default: module.ReactComponent,
  })),
);
const IconUnionPay = lazy(() =>
  import("@assets/ic-union-pay.svg").then((module) => ({
    default: module.ReactComponent,
  })),
);
const IconPaymentCard = lazy(() =>
  import("@assets/ic-payment-card.svg").then((module) => ({
    default: module.ReactComponent,
  })),
);

const brands = {
  visa: "Visa",
  amex: "American Express",
  mastercard: "Mastercard",
  dinnersClub: "Diners Club",
  jcb: "JCB",
  discover: "Discover",
  unionPay: "UnionPay",
};

const brandIconMap = {
  [brands.visa]: IconVisa,
  [brands.amex]: IconAmex,
  [brands.mastercard]: IconMastercard,
  [brands.unionPay]: IconUnionPay,
};

const PaymentCardBrandIcon = ({ brand }) => {
  const Icon = brandIconMap[brand] || IconPaymentCard;

  return (
    <Suspense fallback="Loading...">
      <Icon width={28} height={28} />
    </Suspense>
  );
};

export default PaymentCardBrandIcon;
